<div class="layout-column full-height">
  <div class="layout-row layout-align-start-center gap-5">
    <app-bringoz-date-range-picker appBringozIdGenerator="account-threepl-services-date-range-picker"
                                   [customTemplates]="customTemplates"
                                   [selectedRange]="range()"
                                   (onChange)="rangeChanged($event)">
    </app-bringoz-date-range-picker>

    <app-threepl-service-status-selector [selectedStatus]="status()"
                                         [statusList]="statusList"
                                         (statusChange)="onStatusChange($event)">
    </app-threepl-service-status-selector>

    <bz-search-input class="account-threepl-services-search"
                     appBringozIdGenerator="filterSearchInput"
                     [placeholder]="'Search Delivery' | translate"
                     [debounceMs]="1000"
                     (valueChange)="submitQuery($event)">
    </bz-search-input>

    <span class="flex"></span>
  </div>

  <app-threepl-services-table class="flex"
                              [items]="vm().items"
                              [loading]="vm().loading"
                              [columns]="columns"
                              [layout]="layout"
                              [selectedServiceIds]="selectedIds()"
                              [sortType]="sortValue()"
                              (toggleService)="onToggleService($event)"
                              (moveToInternal)="onMoveToInternal($event)"
                              (sortTypeChange)="onSortTypeChange($event)"
                              (fetchNext)="store.loadMore()"
                              (layoutChange)="onTableLayoutChange($event)">
  </app-threepl-services-table>

  @if (selectedIds().length) {
    <app-threepl-service-action-footer [selectedServices]="selectedServices()"
                                       (unselectAll)="onUnselectAll()"
                                       (cancelServices)="onCancelSelectedServices()"
                                       (addNoteToServices)="onAddNoteToSelectedServices($event)">
    </app-threepl-service-action-footer>
  }
</div>
